import { Upload } from "antd";
import { DraggerProps, UploadProps } from "./type";

function AntUpload<T>(props: UploadProps<T>) {
  return <Upload<T> {...props} />;
}

function AntUploadDragger(props: DraggerProps) {
  return <Upload.Dragger {...props} />;
}

export { AntUpload as Upload, AntUploadDragger as Dragger };
